import React, { useRef, useState,useEffect } from 'react'
import {
    Breadcrumb,
    Dropdown,
    Flex,
    Row,
    Col,
    theme,
    FloatButton,
    Form,
    Input,
    Button,
    Image,
    Upload,
    Divider,
    DatePicker,
    Tooltip,
    Checkbox,
    Radio,
    message,
	Tag,
	Select
} from 'antd';
import { useSelector } from 'react-redux';
import {
    PlusOutlined
} from '@ant-design/icons';
import TextEditor from '../../../helperComponents/TextEditor';
import { Option } from 'antd/es/mentions';
import dayjs from "dayjs";

const SelectedTemplate=({setTemplateViewsate,template}) =>{
    // const iframeRef =useRef(null);
	const { companyId, token, userCompany, role } = useSelector(state => state.auth);
	const {
			token: { colorBgContainer, borderRadiusLG, colorBorder },
		} = theme.useToken();

  //   <style>
  //   @import url("https://cdnjs.cloudflare.com/ajax/libs/antd/4.24.3/antd.min.css");
  //   body { margin: 20px; font-family: Arial, sans-serif; }
  // </style>
  	const [rows,setRows] = useState([]);
	const [hoveredRowId, setHoveredRowId] = useState(null);
	const [droppedContent, setDroppedContent] = useState({});
	const [form] = Form.useForm();
	const [previewOpen, setPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [fileList, setFileList] = useState([]);
	const [templateName, settemplateName] = useState("");
	const [count, setCount] = useState(0);
	const [formData,setFormData] = useState({})

	const [mainTemplate,setMainTemplate] = useState(null)

	const inputRefs = useRef({});
  	
	const style = {
		filterStyle: {
			border: `1px dashed ${colorBorder}`,
			padding: 4,
			minHeight: 60,
			position: 'relative',
		},
	};
	const getBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});
	useEffect(() => {
		// let k = JSON.stringify(rows);
		console.log("Current Updated files state:", fileList); 
		// This runs whenever `data` changes
	  }, [fileList]);
	useEffect(()=>{
		console.log(rows,"selected template state change")
		let str = JSON.stringify(rows);
		let temp = {...template}
		temp.templateContent=str;
		setTemplateViewsate(temp);
	},[rows])
	useEffect(()=>{
		
		console.log(template,"seeeeleeecteedd template")
		const jsonObject = JSON.parse(template.templateContent);
		console.log(jsonObject,"selected templateJsonString")

		updateFileList(jsonObject);
		console.log(jsonObject)
		setRows(jsonObject);
		setMainTemplate(template)
	},[])
  

	const updateFileList=(jsonObject)=>{
		let filearray = []
		jsonObject.forEach((record)=>{
			if(record.fields.length>0){
				record.fields.forEach((field)=>{
					let cellId=field.cellId;
					if(field.filelist.length>0){
						let subarray = []
						field.filelist.forEach((file,index)=>{
							let filename = `image-${index}`
							const tempfile = base64ToImageFile(file.image,filename)
							const obj = {
								uid: new Date().getTime().toString(), // Unique ID
								name: filename,
								status: "done",
								thumbUrl: file.image, 
								originFileObj: tempfile
							}
							// console.log(obj,"image indexxxxx")
							subarray.push(obj);
							
						})
						filearray[cellId]=subarray;
					}
				})
			}
		})
		setFileList(filearray);
		// console.log(filearray,"fifififile aarrraay")
		// const base64Image = "data:image/png;base64,iVBORw0KGgo...";
		// const file = base64ToImageFile(base64Image, "image.png");
	}

	const base64ToImageFile=(base64String, fileName) =>{
		const arr = base64String.split(",");
		const mime = arr[0].match(/:(.*?);/)[1];
		const byteString = atob(arr[1]); // Decode Base64
		const byteArray = new Uint8Array(byteString.length);
	  
		for (let i = 0; i < byteString.length; i++) {
		  byteArray[i] = byteString.charCodeAt(i);
		}
	  
		return new File([byteArray], fileName, { type: mime });
	  }
	const getdropcontent=(item,row)=>{
		let dropcontent = <></>

		dropcontent = (item.content === 'TextEditor') ? (
			<>
				<Tag >{item.label}</Tag>
				<TextEditor name={`${item.cellId}`} onchangefunction={onChangeInputValue} item={item} row={row} />
			</>
			
		) : (item.content === 'Title') ? (
			<>
				<Tag >{item.label}</Tag>
				{/* <Form.Item name={`${item.cellId}`}  style={{ margin: 10 }} > */}
					<Input ref={(el) => (inputRefs.current[item.cellId] = el)} name={`${item.cellId}`} value={item.value} onChange={(e)=>{onChangeInputValue(e,item.cellId,row)}} placeholder="Enter title here" />
				{/* </Form.Item> */}
			</>
		) : item.content === 'DateField' ? (
			<>
				<Tag >{item.label}</Tag>
				{/* <Form.Item name={`date-${item.cellId}`} style={{ margin: 10 }}> */}
					<DatePicker value={item.value ? dayjs(item.value) : null} onChange={(date, dateString)=>{handleDateChange(date, dateString,item.cellId,row)}}/>
				{/* </Form.Item> */}
			</>
		) : item.content === 'ImageUploader' ? (
			renderImageUploader(item,row)
			
		) : item.content === 'Signature' ? (
			renderImageUploader(item,row)
		) : item.content === 'Divider' ? (
			<Divider />
		) : item.content === 'CheckGroup' ? (
			<>
				<Tag >{item.label}</Tag>
				<Form.Item style={{ margin: 12 }}>
					<Checkbox.Group onChange={(e)=>onChangeCheckBoxes(e,item.cellId,row)} value={item.value} style={{ width: '100%' }}>
						{item.options.map((option) => (
							<>
								{!option.disabled ?
								<Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8, width: '100%' }}>
									<Checkbox disabled={option.disabled}  key={option.id} value={option.id} >{option.value}</Checkbox>
								</Flex>
								:<></>
								}
							</>
							
						))}
					</Checkbox.Group>
				</Form.Item>
			</>
			
		) : item.content === 'RadioGroup' ? (
			<>
				<Tag >{item.label}</Tag>
				<Form.Item style={{ margin: 12 }}>
					<Radio.Group style={{ width: '100%' }}  onChange={(e)=>{onChangeInputValue(e,item.cellId,row)}} value={item.value}>
						{item.options.map((option) => (
							<>
								{!option.disabled ?
									<Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8 }}>
										<Radio disabled={option.disabled} key={option.id} value={option.id} >{option.value}</Radio>
									</Flex>
								:<></>
								}
							</>
							
						))}
					</Radio.Group>
				</Form.Item>
			</>
		) : item.content === 'SelectGroup' ? (
			<>
				<Tag >{item.label}</Tag>
				<Form.Item style={{ margin: 12 }}>
					<Select style={{ width: '100%' }} onChange={(e)=>{setSelectedValue(e,item.cellId,row)}} value={item.value}>
						{item.options.map((option) => (
							<>
							{!option.disabled ?
								// <Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8 }}>
									<Option key={option.id} value={option.id}>{option.value}</Option>
								// </Flex>
							:<></>
							}
							</>
							
						))}
					</Select>
				</Form.Item>
			</>
		) : null
		

		return dropcontent;
		
	}

	
	const setSelectedValue =(e,cellId,row)=>{
		let obj ={
            target:{
                value:e
            }
        }
        onChangeInputValue(obj,cellId,row)
	}

	const onChangeInputValue=(e,cellId,row) => {
        
        let currentstate = [...rows]

        let edited = currentstate.map((item) =>
            item.id === row
              ? {
                  ...item,
                  //fields: [...(item.nestedList || []), dropedObject],
                  fields: item.fields.map((nestedItem) =>
                    nestedItem.cellId === cellId
                      ? { ...nestedItem, value: e.target.value } // Update the nested item's value
                      : nestedItem
                    )
                }
              : item)

        setRows(edited);

        if (inputRefs.current[cellId]) {
            inputRefs.current[cellId].focus();
        }
    }
	const handleDateChange = (date, dateString,cellId,row) => {
        // `date` is a Day.js object
        // `dateString` is the formatted date as a string
        console.log(date,"date")
        console.log(dateString,"date string")

        let obj ={
            target:{
                value:dateString
            }
        }
        onChangeInputValue(obj,cellId,row)
        // setFormData((prevState) => ({
        //     ...prevState, // Spread the existing state
        //     [cellId]: date // Add the new attribute with a value
        // }));
      };

	const onChangeCheckBoxes = (checkedValues,cellId,row) => {
        // console.log("Checked values:", checkedValues);
        let str = JSON.stringify(checkedValues);
        let obj ={
            target:{
                value:checkedValues
            }
        }
        onChangeInputValue(obj,cellId,row);
        // console.log(str);
    };
	const savefilelist =(base64Images,item,row)=>{
        console.log(base64Images,'jjdjdjjdjdj')
        let currentstate = [...rows]

        currentstate.forEach((objc)=>{
            if(objc.id===row){
                objc.fields.forEach((field)=>{
                    if(field.cellId===item.cellId){
                        field.filelist=base64Images
                    }
                })
            }
        })
        setRows(currentstate);
    }
    

	const renderImageUploader = (item,row) => {
        const handlePreview = async (file) => {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            setPreviewImage(file.url || file.preview);
            setPreviewOpen(true);
        };

        const handleFileChange = async({ fileList }) =>
            {
                setFileList((prevState) => ({
					...prevState, 
					[item.cellId]: fileList, 
				}));
	
				const imagePromises = fileList.map((file,index) => {
					return new Promise((resolve) => {
					const reader = new FileReader();
					reader.readAsDataURL(file.originFileObj);
					reader.onload = () => resolve({ id: index, image: reader.result }); // Get Base64 string
					});
				});
			
				// Wait for all images to be processed
				const base64Images = await Promise.all(imagePromises);
				savefilelist(base64Images,item,row)
            } 

        const uploadButton = (
            <Button type='text' icon={<PlusOutlined />} style={{ width: '100%' }}>
                Upload
            </Button>
        );

    	return (
            <>
                <Tag>{item.label}</Tag>
                <Upload
                    action="https://example.com/upload"
                    listType="picture-card"
                    fileList={fileList[item.cellId]}
                    onPreview={handlePreview}
					beforeUpload={() => false}
                    onChange={handleFileChange}
                >
                    {fileList.length >= 8 ? null : uploadButton}
                </Upload>
                {previewImage && (
                    <Image
                        wrapperStyle={{ display: 'none' }}
                        preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) => setPreviewOpen(visible),
                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                        }}
                        src={previewImage}
                    />
                )}
            </>
        );
    };

	const renderRow = (row, index) => {
		const columns = [];
		const columnCount = row.type === '1' ? 1 : row.type === '2' ? 2 : 3;
		const span = 24 / columnCount;

		const fields = row.fields;

		for (let i = 0; i < columnCount; i++) {
			const cellId = `${row.id}-${i}`;

			columns.push(
				<Col
					key={cellId}
					span={span}
					// style={{ ...style.filterStyle }}
				>
					{fields.length !== 0 ?
					<>
					{fields.map((item,index)=>{
						if(cellId===item.cellId){
						return getdropcontent(item,row.id)
							
						}
						
					})}
					</>:
					<>
					</>

					}
					
				</Col>
			);
		}

		return (
			// <SortableItem
			//     key={row.id}
			//     id={row.id}
			//     onMouseEnter={() => setHoveredRowId(row.id)}
			//     onMouseLeave={() => setHoveredRowId(null)}
			// >
			<div
				key={row.id}
				id={row.id}
			>
				<Row style={{ marginBottom: '16px', position: 'relative' }}>
					{/* {hoveredRowId === row.id && (
						<Button
						icon={<HolderOutlined/>}
						type='text'
							style={{
								position: 'absolute',
								right: 64, 
								top: '50%',
								transform: 'translateY(-50%)',
								fontSize: 24, 
								zIndex:99
							}}
						/>
					)} */}
					{columns}
				</Row>
			</div>
			// </SortableItem>
		);
	};

	return (
		<>
			<div style={{ padding: '8px 16px' }}>
				<Form>
					
					{rows.map((row,index)=>renderRow(row, index))}

				</Form>
			</div>
		</>
	)
}
export default SelectedTemplate